<template>
  <a-select
    v-model="localValue"
    :options="vSelectOptions"
    bind-by-object
    :id="id"
    :disabled="disabled"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    ref="select"
  ></a-select>
</template>

<script lang="ts">
import Vue from "vue";
import { IVOptionSetEndpoint } from "../../interfaces/vSelectInterfaces";
import LocalValueEmissionMixin from "../../mixins/localValueEmissionMixin";

export default Vue.extend({
  mixins: [LocalValueEmissionMixin],
  props: {
    organizationId: {
      type: String,
      default: ""
    },
    endpointOptions: {
      type: Object,
      default: () => {
        return { per_page: 5 };
      }
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    autocomplete: {
      type: String,
      default: "on"
    },
    placeholder: {
      type: String,
      default: "Search forms..."
    },
    analystDashboardEndpoint: {
      type: Boolean,
      default: false
    },
    noneOption: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {};
  },
  computed: {
    vSelectOptions: {
      get(): IVOptionSetEndpoint {
        let endpoint: string;
        if (this.analystDashboardEndpoint) {
          endpoint = `/analyst_dashboard/search_forms`;
        } else {
          endpoint = `/organizations/${this.organizationId}/search_forms`;
        }

        let options = {
          valueKey: "id",
          labelKey: "title",
          endpoint,
          endpointOptions: this.endpointOptions,
          rootKey: "forms",
          selectedOption: this.localValue
        };

        ["actionButton"].forEach(key => {
          if (this.options[key]) {
            options[key] = this.options[key];
          }
        });

        if (this.noneOption) {
          // when user has an empty search query, they will be given the option of selecting "None", which can be handled on a case-by-case basis
          options["options"] = [{"title": "None", "id": null}]
        }

        return options;
      }
    }
  }
});
</script>
